// import { App } from "vue";
// import ltAFrame from './src/main.vue';
// ltAFrame.install = (app:App) => {
//   app.component(ltAFrame.name, ltAFrame);
// };

// export default ltAFrame;


import { withInstall } from "../../utils/install";
import AFrame from "./src/main.vue";

export const ltAFrame = withInstall(AFrame);
export default ltAFrame;

